import React, { ReactNode } from 'react'
import { AppSearchData } from './AppGridSearchData'

interface AppGridSearchContext {
	appSearchDataList: AppSearchData[]
	showMore: boolean
	onSearch: () => void
	onChange: (appSearchData: AppSearchData) => void
	handleClickMore: () => void
	clearSearchDataByField: (keyName: string) => void
	calAppGridSearchHeight: () => void
	// clearSearch: () => void
}

export const AppGridSearchContext = React.createContext<AppGridSearchContext>({} as AppGridSearchContext)



// WEBPACK FOOTER //
// ./src/components/AppTableSearch/AppGridSearchContext.tsx